import { rangeSlider, filterSelect, filterCheckbox, filterHidden, filterReleasesCheckbox } from './inputs';
import activateSaveProductButtons from './saveProduct';
import { updateFilterCriteria, filterProducts, getFilterCriteria } from '../maps/filter';
import { renderProductCards } from './renderProductCards';
import { renderPlacesOfInterest } from '../placesOfInterest';
import { getFormData } from '../forms/data';

// Default Settings
var globals = {};
var markerIcons = {
  active: {},
  inactive: {}
};
var markers = [];
const data = {
  products: []
};
var gtmLots = {};
function Lot(name= "",type = "", size = "", price = "", stage = "", bedrooms = "", bathrooms = "", car_spaces = "", stories = "", product_id = "", open_times = "", builder = "", frontage = "") {
    this.name = name;
    this.type = type;
    this.size = size;
    this.price = price;
    this.stage = stage;
    this.bedrooms = bedrooms;
    this.bathrooms = bathrooms;
    this.car_spaces = car_spaces;
    this.stories = stories;
    this.product_id = product_id;
    this.open_times = open_times;
    this.builder = builder;
    this.frontage = frontage;
}

export const products = async (g) => {
  globals = g;

  // Initilize default marker styles
  markerIcons.inactive = {
    url: '/images/pin-icon.svg',
    size: new google.maps.Size(25, 40),
    scaledSize: new google.maps.Size(25, 40),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(12, 40)
  };
  markerIcons.active = {
    url: '/images/pin-icon-active.svg',
    size: new google.maps.Size(25, 40),
    scaledSize: new google.maps.Size(25, 40),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(12, 40)
  };

  var endpoint = globals.apiRoot + '/project-data?projectId=' + globals.projectIds.join("&projectId=");

  $.when($.ajax(endpoint))
    .done(function (response) {
      // Set the values
      data.mainProject = response.mainProject;
      data.products = response.lots;
      data.placesOfInterest = response.pointsOfInterest;
      prepareMap(data.products);
      setFilterBoundaries();
      initializeControls();
      enableViewTogglers();
      renderPlacesOfInterest(data.placesOfInterest, globals);
      gtmViewLotList(data); // trigger GTM (View Lot List)

      // Check if there are no markers and reset map
      if (markers.length === 0) {
        setMapBounds();
      } 
    })
    .fail(function () {
      console.log(arguments);
    });
};

export const deactivateProductMarkers = () => {
  markers.forEach(marker => marker.setIcon(markerIcons.inactive));
}

const setFilterBoundaries = () => {
  var filterSettings = {
    containsLand: false,
    containsHL: false,
    containsApartment: false,
    containsTerrace: false,
    containsTownhouses: false,
    lotSizeMin: -1,
    lotSizeMax: -1,
    frontageMin: -1,
    frontageMax: -1,
    priceMin: -1,
    priceMax: -1,
    beds: [],
    baths: [],
    cars: [],
    releases: []
  }

  data.products.forEach(lot => {

    if (lot.lotSize !== undefined) {
      filterSettings.lotSizeMin = (filterSettings.lotSizeMin == -1 || lot.lotSize < filterSettings.lotSizeMin) ? lot.lotSize : filterSettings.lotSizeMin;
      filterSettings.lotSizeMax = (filterSettings.lotSizeMax == -1 || lot.lotSize > filterSettings.lotSizeMax) ? lot.lotSize : filterSettings.lotSizeMax;
    }
    if (lot.lotWidth !== undefined) {
      filterSettings.frontageMin = (filterSettings.frontageMin == -1 || lot.lotWidth < filterSettings.frontageMin) ? lot.lotWidth : filterSettings.frontageMin;
      filterSettings.frontageMax = (filterSettings.frontageMax == -1 || lot.lotWidth > filterSettings.frontageMax) ? lot.lotWidth : filterSettings.frontageMax;
    }

      if (lot.release !== undefined && lot.status.toLowerCase() === "available") {
      filterSettings.releases.push(lot.release.name);
    }

    lot.products.forEach(product => {
      filterSettings.containsLand = filterSettings.containsLand || product.type == "Land";
      filterSettings.containsHL = filterSettings.containsHL || product.type == "House and Land";
      filterSettings.containsApartment = filterSettings.containsApartment || product.type == "Apartment";
      filterSettings.containsTerrace = filterSettings.containsTerrace || product.type == "Terrace Home";
      filterSettings.containsTownhouses = filterSettings.containsTownhouses || product.type == "Townhouse";

      if (product.bedrooms !== undefined && product.bedrooms != null) {
        filterSettings.beds.push(product.bedrooms);
      }
      if (product.bathrooms !== undefined && product.bathrooms != null) {
        filterSettings.baths.push(product.bathrooms);
      }
      if (product.garageSpaces !== undefined && product.garageSpaces != null) {
        filterSettings.cars.push(product.garageSpaces);
      }
      if (product.price !== undefined) {
        filterSettings.priceMin = (filterSettings.priceMin == -1 || product.price < filterSettings.priceMin) ? product.price : filterSettings.priceMin;
        filterSettings.priceMax = (filterSettings.priceMax == -1 || product.price > filterSettings.priceMax) ? product.price : filterSettings.priceMax;
      }
    });
  });

  $('div[name="Area"]').attr('data-min', filterSettings.lotSizeMin).attr('data-default-min', filterSettings.lotSizeMin);
  $('div[name="Area"]').attr('data-max', filterSettings.lotSizeMax).attr('data-default-max', filterSettings.lotSizeMax);
  $('div[name="Price"]').attr('data-min', filterSettings.priceMin).attr('data-default-min', filterSettings.priceMin);
  $('div[name="Price"]').attr('data-max', filterSettings.priceMax).attr('data-default-max', filterSettings.priceMax);

  var beds = sortedUnique(filterSettings.beds);
  beds.forEach(option => $('select.product-search__filter-select[name="Beds"]').append("<option>" + option + "</option>"))

  var baths = sortedUnique(filterSettings.baths);
  baths.forEach(option => $('select.product-search__filter-select[name="Baths"]').append("<option>" + option + "</option>"))

  var cars = sortedUnique(filterSettings.cars);
  cars.forEach(option => $('select.product-search__filter-select[name="Carbays"]').append("<option>" + option + "</option>"))

  if ($('.release-types').length) {
    var releases = sortedUnique(filterSettings.releases);
    releases.forEach(option => {
      //var releaseData = option.split(":");
      //var id = releaseData[0];
       // var name = releaseData[1];
        var name = option;
      $('.property-types.release-types .property-types__options').append('<label class="form__control-group form__control-group--releases form__control-group--checkbox">' +
          '<input class="form__control-group releases-search__filter-checkbox" name="Releases" id="' + name + '" value="' + name + '" type="checkbox">' +
        '<checkboxicon class="icon-wrapper"><svg class="icon icon_checkbox" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path class="background" d="M15.61,18H2.39A2.39,2.39,0,0,1,0,15.61V2.39A2.39,2.39,0,0,1,2.39,0H15.61A2.39,2.39,0,0,1,18,2.39V15.61A2.39,2.39,0,0,1,15.61,18Z"></path><rect x="-3" y="-3" width="24" height="24" style="fill: none;"></rect><path class="border" d="M15.61,18H2.39A2.39,2.39,0,0,1,0,15.61V2.39A2.39,2.39,0,0,1,2.39,0H15.61A2.39,2.39,0,0,1,18,2.39V15.61A2.39,2.39,0,0,1,15.61,18ZM3.22,2A1.22,1.22,0,0,0,2,3.22V14.78A1.22,1.22,0,0,0,3.22,16H14.78A1.22,1.22,0,0,0,16,14.78V3.22A1.22,1.22,0,0,0,14.78,2Z"></path><polygon class="foreground" points="7 14 2 9.19 3.4 7.85 7 11.31 14.6 4 16 5.35 7 14"></polygon></svg></checkboxicon>' +
          '<label for="' + name + '">' + name + '</label>' +
        '</label>')
    })
  }
};


const sortedUnique = (arr = []) => {
  const map = {};
  const res = [];
  for (let i = 0; i < arr.length; i++) {
    if (!map[arr[i]]) {
      map[arr[i]] = true;
      res.push(arr[i]);
    };
  };
  return res.sort((a, b) => a - b);
};

const getFormDetailsForInput = (input) => {
  const $input = $(input);
  const $form = $input.closest('form');
  const endpoint = $form.attr('action');
  const method = $form.attr('method');
  return { endpoint, method };
};

const clone = (productData) => {
  return JSON.parse(JSON.stringify(productData));
};

const updateSearch = (update, action, input) => {
  if (update) {
    updateFilterCriteria({ update, action });

    var filteredData = filterProducts(clone(data.products));
    renderProductPins(filteredData);
    renderProductCards('product-card-wrapper', filteredData, data.mainProject.name);
    populateDataLayerObject(filteredData);
    
  }
};

function populateDataLayerObject(data) { //this allows me to update an array of lot objects I can attached to a datalayer push later. Excluding lots with status of sold
    gtmLots = [];
    
    data.forEach(function (item) {
        if (item.status != "Sold") {
            for (var i = 0; i < item.products.length; i++) {
                gtmLots.push(new Lot(
                    item.name,
                    item.products[i].type,
                    item.lotSize,
                    item.products[i].price,
                    item.release.name,
                    item.products[i].bedrooms,
                    item.products[i].bathrooms,
                    item.products[i].garageSpaces,
                    item.products[i].storeys,
                    ExtractGUIDFromUrl(item.products[i].url),
                    "open times unavailable",
                    item.products[i].builderName,
                    item.lotWidth
                ));
            }
        }
    });
}

const initializeControls = () => {

  var inputs = document.getElementsByClassName('product-search__filter-checkbox')
    for (var i = 0; i < inputs.length; i++) {
      var diff = 0;
      if (globals.productFilter !== null) {
        // to ensure if parameter includes 'Land' that it is not part of 'House and Land'. diff in index must not be 4
        // if parameter is 'Land Townhouse' then it reads the and part of Land as and and diff is 4 
        // they don't expect to use multiple product types in the parameters and trying to find a solution that doesn't require changing the keyword everywhere is fraught.
        var indexOfAnd = globals.productFilter.indexOf("and");
        var indexOfValue = globals.productFilter.indexOf(inputs[i].value);
        diff = indexOfValue - indexOfAnd;
      }
      
    if ((!globals.productFilter || globals.productFilter.indexOf(inputs[i].value) >= 0) && diff !== 4) {
      inputs[i].checked = 'checked';
    }
  }

  initializeFilterInputs();
  initializeMapFilterToggle();
  activateSaveProductButtons();

  setMapHeight();
  setFixedFilterScroll();

}

const initializeFilterInputs = () => {
  filterHidden(updateSearch);
  rangeSlider(updateSearch, '.product-search__filter-range-slider');
  filterSelect(updateSearch);
  filterCheckbox(updateSearch);
  filterReleasesCheckbox(updateSearch);

  // Set GTM events when filter controls are adjusted...
  Array.from(document.querySelectorAll('.product-search__filter-range-slider, .range-slider')).forEach((slider) => {
    slider.noUiSlider.on('change', () => { gtmEventFilters(getFilterCriteria()) });
  });

  Array.from(document.querySelectorAll('.product-search__filter-select')).forEach((input) => {
    input.addEventListener('change', () => { gtmEventFilters(getFilterCriteria()) });
  });

  Array.from(document.querySelectorAll('.product-search__filter-checkbox')).forEach((input) => {
    input.addEventListener('change', () => { gtmEventFilters(getFilterCriteria()) });
  });

  Array.from(document.querySelectorAll('.releases-search__filter-checkbox')).forEach((input) => {
    input.addEventListener('change', () => { gtmEventFilters(getFilterCriteria()) });
  });

}

const initializeMapFilterToggle = () => {
  const $productFilterToggle = $('#product-search__filter-toggle');
  const $contentScrollContainer = $('.mdl-layout__content');
  $productFilterToggle.on('change', () => {
    $contentScrollContainer.scrollTop(0);
  });
};

function prepareMap(productData) {
  renderOverlay(data.mainProject, productData);

  var clusterOptions = {
    ignoreHidden: true,
    minimumClusterSize: 5,
    styles: [{ textColor: "#FFFFFF", textSize: 14, width: 56, height: 56, url: '/images/cluster-icon.png' }]
  };

  globals.cluster = new MarkerClusterer(globals.map, markers, clusterOptions);

};

function renderProductPins(data) {
    //for testing purpoises
    //console.log("i'm going to pause");
    //var start = new Date().getTime();
    //var end = start;
    //while (end < start + 10000) {
    //    end = new Date().getTime();
    //}
    //console.log("finished pausing");

  // Remove any existing markers
  markers.forEach(marker => {
    globals.cluster.removeMarker(marker);
    marker.setMap(null);
  });
  markers = [];

  data.forEach(lot => {
    if (lot.status.toLowerCase() !== "sold") {
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(lot.lat, lot.lng),
        icon: markerIcons.inactive
      });

      (function (marker, lot) {
        google.maps.event.addListener(marker, "click", function (e) {
          const contentString = infoWindowMarkup(lot);
          globals.showHideInfoWindow(marker, contentString);
            marker.setIcon(markerIcons.active)
            //GTM if item on map clicked fire (Map Interaction) will need community and lot objects
        });

      })(marker, lot);

      markers.push(marker);
      globals.cluster.addMarker(marker);
    }
  });

  if (markers.length > 0) {
    setMapBounds();
  }

  hideLoader();
  
};



function setMapBounds() {

  var bounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(data.mainProject.south, data.mainProject.west),
    new google.maps.LatLng(data.mainProject.north, data.mainProject.east));

  if (markers.length) {

    var firstMarker = markers[0];
    bounds = new google.maps.LatLngBounds(firstMarker.position, firstMarker.position);

    markers.forEach(marker => {
      bounds.extend(marker.position);
    })

    // Create a min bounds size for filtering (prevents zooming too far without restricting manual zoom)
    var boundsMin = 0.001;
    var latDif = bounds.getNorthEast().lat() - bounds.getSouthWest().lat();
    var lngDif = bounds.getNorthEast().lng() - bounds.getSouthWest().lng();
    if (latDif < boundsMin || lngDif < boundsMin) {
      var lngBuff = boundsMin - lngDif;
      var latBuff = boundsMin - latDif;
      var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + latBuff, bounds.getNorthEast().lng() + lngBuff);
      var extendPoint2 = new google.maps.LatLng(bounds.getSouthWest().lat() - latBuff, bounds.getSouthWest().lng() - lngBuff);
      bounds.extend(extendPoint1);
      bounds.extend(extendPoint2);
    }

  }

  globals.map.fitBounds(bounds);
};

function renderOverlay(projectInformation, products) {
  // Get svg and create inline defs element
  if (projectInformation.overlayImageUrl && projectInformation.overlayImageUrl !== "") {
    let getOverlayImage = new XMLHttpRequest();
    getOverlayImage.open("GET", projectInformation.overlayImageUrl, false);
    getOverlayImage.overrideMimeType("image/svg+xml");
    getOverlayImage.onload = function () {
      var getOverlayDocElement = getOverlayImage.responseXML.documentElement;
      products.forEach(lot => {
        var lotId = 'lot_' + lot.lotNumber;
        var lotLabelId = 'lot_name_' + lot.lotNumber;
        var lotStatus = lot.status.toLowerCase();
        var polyElement = getOverlayDocElement.getElementById(lotId);
        var labelElement = getOverlayDocElement.getElementById(lotLabelId);
        if (polyElement) {
          if (['available', 'sold', 'pending'].includes(lotStatus)) { polyElement.classList.add('lot-' + lotStatus); }
          else { polyElement.classList.add('lot-unavailable'); }
        }
        if (labelElement) {
          if (['available', 'sold', 'pending'].includes(lotStatus)) { labelElement.classList.add('lot-' + lotStatus); }
          else { labelElement.classList.add('lot-unavailable'); }
        }
      });

      document.getElementById("svgOverlay").appendChild(getOverlayImage.responseXML.documentElement);
    }
    getOverlayImage.send("");

    // The custom USGSOverlay object contains the USGS image, the bounds of the image, and a reference to the map.
    class USGSOverlay extends google.maps.OverlayView {
      constructor(overlayBounds) {
        super();
        this.bounds = overlayBounds;
        this.svg = document.getElementById("svgOverlay").innerHTML;
      }

      // onAdd is called when the map's panes are ready and the overlay has been added to the map.
      onAdd() {
        this.div = document.createElement("div");
        this.div.setAttribute("class", "product-search__map-overlay-wrapper")
        // this.div.style.borderStyle = "solid";
        // this.div.style.borderWidth = "1px";
        this.div.style.position = "absolute";

        const svg = document.createElement("svg");
        svg.innerHTML = this.svg;
        svg.style.position = "absolute";
        svg.style.width = "100%";
        svg.style.height = "100%";
        svg.setAttribute("class", "product-search__map-overlay-svg")
        this.div.appendChild(svg);

        // Add the element to the "overlayLayer" pane.
        const panes = this.getPanes();
        panes.overlayLayer.appendChild(this.div);
      }

      draw() {
        const overlayProjection = this.getProjection();
        const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest());
        const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast());

        // Resize the image's div to fit the indicated dimensions.
        if (this.div) {
          this.div.style.left = sw.x + "px";
          this.div.style.top = ne.y + "px";
          this.div.style.width = ne.x - sw.x + "px";
          this.div.style.height = sw.y - ne.y + "px";
        }
      }

      // The onRemove() method will be called automatically from the API if we ever set the overlay's map property to 'null'.
      onRemove() {
        if (this.div) {
          this.div.parentNode.removeChild(this.div);
          delete this.div;
        }
      }

      // Set the visibility to 'hidden' or 'visible'.
      hide() {
        if (this.div) { this.div.style.visibility = "hidden"; }
      }

      show() {
        if (this.div) { this.div.style.visibility = "visible"; }
      }

      toggle() {
        if (this.div) {
          if (this.div.style.visibility === "hidden") { this.show(); } else { this.hide(); }
        }
      }

      toggleDOM(map) {
        if (this.getMap()) { this.setMap(null); } else { this.setMap(map); }
      }

    }

    const overlay = new USGSOverlay(new google.maps.LatLngBounds(
      new google.maps.LatLng(projectInformation.south, projectInformation.west),
      new google.maps.LatLng(projectInformation.north, projectInformation.east)
    ));

    overlay.setMap(globals.map);
  }
}

// Turns on toggle events + set default view ('map' or 'list')
function enableViewTogglers() {
  var defaultView = 'list';
  document.getElementById('product-search-view').classList.add(defaultView + '-view');
  document.getElementById('filter-view-' + defaultView).setAttribute('checked', 'checked');

  var viewTypeRadios = document.getElementsByName('productViewType');
  for (var i = 0; i < viewTypeRadios.length; i++) { viewTypeRadios[i].onchange = toggleResultsView; }

  document.getElementById('filter-toggle').addEventListener('click', toggleFilterView);
  document.getElementById('filter-close').addEventListener('click', toggleFilterView);
  document.getElementById('filter-close-mobile').addEventListener('click', toggleFilterView);

}

function toggleResultsView() {
  var productSearchWrapper = document.getElementById('product-search-view');
  productSearchWrapper.classList.toggle('map-view');
  productSearchWrapper.classList.toggle('list-view');
  setMapBounds();

  // GTM (Google Tag Manager) Data Layer Update
  var viewTypeRadios = document.getElementsByName('productViewType');
  for (var i = 0; i < viewTypeRadios.length; i++) {
    if (viewTypeRadios[i].checked) {
      gtmEventViewToggle(viewTypeRadios[i].value);
    }
  }

}

function toggleFilterView() {
  var productSearchWrapper = document.getElementById('product-search-view');
  productSearchWrapper.classList.toggle('show-filters');
}

function setMapHeight() {
  var vw = $(window).width();
  var filterHeight = $('#product-filter-panel').outerHeight();
  var mapPresetMin = $('#product-search-map').css('min-height').replace('px', '');

  if (mapPresetMin < filterHeight && vw > 479) {
    $('#product-search-map').css('height', filterHeight + 'px');
    $('#product-search-map').css('min-height', filterHeight + 'px');
  }

}

function setFixedFilterScroll() {
  var vw = $(window).width();

  // If mobile set filter bar to fixed position...
  if (vw < 769) {
    // Retrieve the header
    var headerItem = document.getElementById('root-header');
    if (headerItem) {
      // Make the filter bar fixed position
      var filterBar = $('#filter-bar-mobile');
      filterBar.css('position', 'fixed');
      filterBar.css('top', headerItem.getBoundingClientRect().bottom);

      // Retrieve filter bar item
      var filterBarItem = document.getElementById('filter-bar-mobile');
      if (filterBarItem) {
        var filterBarBottom = filterBarItem.getBoundingClientRect().bottom;
        var filterBarHeight = filterBarItem.getBoundingClientRect().height;

        // Set the filter bar top if the header height changes
        $(window).on('scroll', function () {
          // Retrieve the product search view
          var viewItem = document.getElementById('product-search-view');
          if (viewItem) {
            var view = viewItem.getBoundingClientRect().bottom
            if (view < filterBarBottom) {
              var setNewPos = view - filterBarHeight + 'px'
              filterBar.css('top', setNewPos);
            } else {
              filterBar.css('top', headerItem.getBoundingClientRect().bottom);
            }
          }          
        });
      }
    }  
  }
}

function hideLoader() {
    const player = document.querySelector("lottie-player");
    if (player !== null) {
        player.stop();
    }
  $('#search-loader-outer').hide();
}

function infoWindowMarkup(lotData) {

  var lotSize = lotData.lotSize;
    var lotWidth = lotData.lotWidth;
    var productCount = 0;

  // TODO there is sometime more than one product in lotData.products array. How can we identify which product count we have selected... product_id 
  let dataHTML = 'data-name="' + lotData.project.name +
    '" data-region="' + ExtractRegionFromUrl(lotData.products[0].url) +
    '" data-availablity="' + lotData.status +
    '" data-size="' + lotSize +
    '" data-stage="' + lotData.marketingReleaseName +
    '" data-open_times="unknown at this time" ' + // TODO get opening hours from backend somehow {{ Opening Hours }}', // 7 days a week 11am - 5pm. Public Holidays 1pm - 5pm.
    'data-frontage="' + lotWidth + '" ' +
    'data-productCount="' + lotData.products.length + '"';

  let productHTML = '';

  // If a land product does exist and is filtered replace generic head with land product head...
  // add a GTM id here to handle the (Select Item from Map) event which is supposed to happen on click on the thumbnail or more info button on map view (product-info__more, product-info__elevation)
  lotData.products.forEach(product => {
      if (product.type == 'Land') {
          var suffix = lotData.products.length > 1 ? productCount : '';
          var productDataHTML = 'data-product-name' + suffix + '="' + product.lotItem.name + '" ' + 'data-type' + suffix + '="' + product.type + '" ' +
              'data-price' + suffix + '="' + product.price + '" ' +
              'data-bedrooms' + suffix + '="' + product.bedrooms + '" ' +
              'data-bathrooms' + suffix + '="' + product.bathrooms + '" ' +
              'data-car_spaces' + suffix + '="' + product.garageSpaces + '" ' +
              'data-stories' + suffix + '="' + product.storeys + '" ' +
              'data-product_id' + suffix + '="' + ExtractGUIDFromUrl(product.url) + '" ' +
              'data-builder' + suffix +'="' + product.builderName + '"' ;

      productHTML = (
        '<div class="product-info product-info--land">' +
        '<div class="product-info__details">' +
        '<h2 class="product-info__price">' + product.priceDescription + '</h2>' +
        '<h4 class="product-info__name">' + product.name + '</h4>' +
        '<div class="product-info__stats-container" ' +
        productDataHTML +
        '>' +
        (lotSize ? '<div class="product-info__stats product-info__stats--area" title="' + lotSize + 'm2 lot size">' + lotSize + '</div>' : '') +
        (lotWidth ? '<div class="product-info__stats product-info__stats--width" title="' + lotWidth + ' metre frontage">' + lotWidth + '</div>' : '') +
        '</div>' +
          '<div class="product-info__more">' +
          '<a href="' + product.url + '" target="_blank" id="' + "GTMProdId_" + ExtractGUIDFromUrl(product.url) + '" class="product-info__more-information mdl-button mdl-js-button mdl-button--raised mdl-button--colored">More information</a>' +
        '</div>' +
        '</div>' +
        '</div>'
          );

          productCount++;
    }
  });


  lotData.products.forEach(product => {
      if (product.type != 'Land') {
        var suffix = lotData.products.length > 1 ? productCount : '';
          var productDataHTML = 'data-product-name' + suffix + '="' + product.lotItem.name + '" ' + 'data-type' + suffix +'="' + product.type +
            '" data-price' + suffix +'="' + product.price +
            '" data-bedrooms' + suffix +'="' + product.bedrooms +
            '" data-bathrooms' + suffix +'="' + product.bathrooms +
            '" data-car_spaces' + suffix +'="' + product.garageSpaces+
            '" data-stories' + suffix +'="' + product.storeys +
            '" data-product_id' + suffix +'="' + ExtractGUIDFromUrl(product.url) +
            '" data-builder' + suffix +'="' + product.builderName + '"'

      // add a GTM id here to handle the (Select Item from Map) event which is supposed to happen on click on the thumbnail or more info button on map view (product-info__more, product-info__elevation)
      productHTML = productHTML.concat(
        '<div class="product-info product-info--house-and-land">' +
        '<a class="product-info__elevation" href="' + product.url + '" style="background-image:url(' + product.thumbnailImageUrl + ')"></a>' +
        '<strong class="product-info__price">' + product.priceDescription + '</strong>' +
        '<div class="product-info__category">' + product.type + '</div>' +
        '<div class="product-info__details">' +
        '<img src="' + product.productLogoUrl + '" alt="' + product.builderName + '" class="product-info__builder-logo">' +
        '<h4 class="product-info__name">' + product.name + '</h4>' +
        '<div class="product-info__stats-container" ' +
        productDataHTML +
        '>' +(product.bedrooms ? '<div class="product-info__stats product-info__stats--beds" title="' + product.bedrooms + ' bedrooms">' + product.bedrooms + '</div>' : '') +
        (product.bathrooms ? '<div class="product-info__stats product-info__stats--baths" title="' + product.bathrooms + ' bathrooms">' + product.bathrooms + '</div>' : '') +
        (product.garageSpaces ? '<div class="product-info__stats product-info__stats--cars" title="' + product.garageSpaces + ' car bays">' + product.garageSpaces + '</div>' : '') +
        (product.storeys ? '<div class="product-info__stats product-info__stats--storeys" title="' + product.storeys + ' storeys">' + product.storeys + '</div>' : '') +
        '</div>' +
        '<div class="product-info__more">' +
          '<a href="' + product.url + '" target="_blank" id="' + "GTMProdId_" + ExtractGUIDFromUrl(product.url) +'" class="product-info__more-information mdl-button mdl-js-button mdl-button--raised mdl-button--colored">More information</a>' +
        '</div>' +
        '</div>' +
        '</div>'
        );

        productCount++;
    }
  });


  // Create final card html and return
  let cardHTML = (
    '<div class="product-info__window">' +
    '<div class="product-info__wrapper">' +
    '<div class="product-info__container" ' +
    dataHTML +
    '>' +
    productHTML +
    '</div>' +
    '</div>' +
    '</div>'
  );

  return cardHTML;

}

// Google tag manager / analytics function...
var gtmEventViewToggle = function (value) {
  dataLayer.push({
    'pageCatagory': 'product_search',
    'event': 'view_mode_change',
    'viewMode': value,
  })
}

var gtmEventFilters = function (filterCriteria) { //  (Interact with Filter) also in communities/index.js
    console.log("(interact with filter) function fired for product");

    // Jacob from JaneLee would like to transfer available filter criteria to a string, hopefully less than 100 characters (GA4 hardlimit).
    var filterArray = [];
    filterArray.push("type:" + ((filterCriteria.ProductTypes !== undefined) ? filterCriteria.ProductTypes.join("|") : ""));
    filterArray.push("area:" + filterCriteria.Area.join("-"));
    filterArray.push("price:" + filterCriteria.Price.join("-"));
    filterArray.push("bed:" + ((filterCriteria.Beds !== undefined) ? filterCriteria.Beds : ""));
    filterArray.push("bath:" + ((filterCriteria.Baths !== undefined) ? filterCriteria.Baths : ""));
    filterArray.push("car:" + ((filterCriteria.Carbays !== undefined) ? filterCriteria.Carbays : ""));
    
    var filter = filterArray.join(",");
    if (filter.length > 100) {
        filter.replace("House and Land", "HL");
    }

    dataLayer.push({
        event: "filter_interaction",
        item_list_name: "Lot List",
        // filter_name: "{{ name of filter }}", // Bed
        // filter_value: "{{ value selected in filter }}", // 3
        filter: filter, // LeeJane agreed to complete current filter status
        items: gtmLots
    });
}

// for GTM event, a function to call for (PDF Download) 
export var gtmEventPDFDownload = function (model, docType) {
    console.log("gtmEventPDFDownload fired");

    var community = {
        name: model.EstateName || "corporate",
        region: model.Region,
        projectStatus: model.Availability
    };
    var lot = new Lot(
        model.Name,
        model.ProductType,
        model.LotArea,
        model.DisplayPrice,
        model.MarketingReleaseName,
        model.Bedrooms,
        model.Bathrooms,
        model.Garage,
        model.Storeys,
        model.ID,
        model.DisplaySuiteText,
        model.BuilderName,
        model.LotWidth
    );

    dataLayer.push({
        event: "pdf_download",
        community: community,
        lot: lot,
        filename: docType
    });
}

export var gtmUpdateOrRegisteredInterest = function (projectGAInfo, productGAInfo, form) {
    console.log("gtmUpdateOrRegisteredInterest fired");
    var community = {};
    var lot = {};
    var form = getFormData(form);
    
    if (projectGAInfo != null && projectGAInfo != undefined) {
        community.name = projectGAInfo.getAttribute("data-community-name") || "corporate";
        community.region = projectGAInfo.getAttribute("data-community-region");
        community.availability = projectGAInfo.getAttribute("data-community-availability");       
    }

    if (productGAInfo != null && productGAInfo != undefined) {
        var product = productGAInfo.getAttribute("data-product");
        var productJson = $.parseJSON(product);
        if (productJson != null && productJson != undefined) {
            lot.name = productJson.Name;
            lot.type = productJson.ProductType;
            lot.size = productJson.LotArea;
            lot.price = productJson.DisplayPrice;
            lot.stage = productJson.MarketingReleaseName;
            lot.bedrooms = productJson.Bedrooms;
            lot.bathrooms = productJson.Bathrooms;
            lot.car_spaces = productJson.Garage;
            lot.stories = productJson.Storeys;
            lot.product_id = productJson.ID;
            lot.open_times = productJson.DisplaySuiteText;
            lot.builder = productJson.BuilderName
            lot.frontage = productJson.LotWidth;
        }
    }

    dataLayer.push({
        event: "form_submission_success",
        form_type: "Updates",
        community: community, // if on a Community or Lot page or else undefined
        lot: lot, // if on a Lot page or else undefined
        postcode: form.postcode, // 3132
        suburb: form.suburb, // MITCHAM
        marketing: true, // or false - but in submitting the form they agree
        emailAddress: form.emailAddress,
        firstName: form.firstName,
        lastName: form.lastName,
        phoneNumber: form.phoneNUmber        
    });
}


export var gtmEnquiries = function (projectGAInfo, productGAInfo, form) {
    console.log("gtmEnquiries fired");

    var form = getFormData(form);
    var community = {};
    var lot = {};

    if (projectGAInfo != null && projectGAInfo != undefined) {
        community.name = projectGAInfo.getAttribute("data-community-name") || "corporate";
        community.region = projectGAInfo.getAttribute("data-community-region");
        community.availability = projectGAInfo.getAttribute("data-community-availability");        
    }

    if (productGAInfo != null && productGAInfo != undefined) {
        var product = productGAInfo.getAttribute("data-product");
        var productJson = $.parseJSON(product);
        if (productJson != null && productJson != undefined) {
            lot.name = productJson.Name;
            lot.type = productJson.ProductType;
            lot.size = productJson.LotArea;
            lot.price = productJson.DisplayPrice;
            lot.stage = productJson.MarketingReleaseName;
            lot.bedrooms = productJson.Bedrooms;
            lot.bathrooms = productJson.Bathrooms;
            lot.car_spaces = productJson.Garage;
            lot.stories = productJson.Storeys;
            lot.product_id = productJson.ID;
            lot.open_times = productJson.DisplaySuiteText;
            lot.builder = productJson.BuilderName
            lot.frontage = productJson.LotWidth;
        }
    }

    dataLayer.push({
        event: "form_submission_success",
        form_type: "Enquiry",
        community: community, // if on a Community or Lot page or else undefined
        lot: lot, // if on a Lot page or else undefined
        postcode: form.postcode, // 3132
        suburb: form.suburb, // MITCHAM
        contact_time: form.bestContactTime,
        marketing: true, // or false - submiting form is taken as a true
        emailAddress: form.emailAddress,
        firstName: form.firstName,
        lastName: form.lastName,
        phoneNumber: form.phoneNumber
    });
}

export var gtmContactUs = function (form) {
    console.log("gtmContactUs fired");

    var form = getFormData(form);

    dataLayer.push({
        event: "form_submission_success",
        form_type: "Contact Us",        
        postcode: form.postcode, // 3132
        suburb: form.suburb, // MITCHAM
        contact_time: form.bestContactTime,
        marketing: true, // or false - submitting form is taken as true
        emailAddress: form.emailAddress,
        firstName: form.firstName,
        lastName: form.lastName,
        phoneNumber: form.phoneNumber
    });
}

var gtmViewLotList = function (data) { // (View Lot List) fired when list first viewed as I read the instructions
    // TODO open times

    console.log("fired (View Lot List) GA function");

    var items = [];
    function item(itemguid = "", name = "", builder = "", community = {}, lot = {}) {
        this.item_id = itemguid; //data.product[] 
        this.item_name = name;
        this.item_brand = builder;
        //this.community = community;
        //this.lot = lot;
        if (community !== null && community !== {}) {
            this.community_name = community.name;
            this.community_region = community.region;
            this.community_projectStatus = community.projectStatus;
        }

        if (lot !== null && lot !== {}) {
            this.lot_name = lot.name;           
            this.lot_type = lot.type;
            this.lot_size = lot.size;
            this.lot_price = lot.price;
            this.lot_stage = lot.stage;
            this.lot_bedrooms = lot.bedrooms;
            this.lot_bathrooms = lot.bathrooms;
            this.lot_car_spaces = lot.car_spaces;
            this.lot_stories = lot.stories;
            this.lot_product_id = lot.product_id;
            this.lot_open_times = lot.open_times;
            this.lot_builder = lot.builder;
            this.lot_frontage = lot.frontage;
		}
        
        return this;
    }

    // note each lot may have more than one product, exclude those lots that are sold
    for (var i = 0; i < data.products.length; i++) {
        for (var j = 0; j < data.products[i].products.length; j++) {
            if (data.products[i].status != "Sold") {
                items.push(new item(
                    ExtractGUIDFromUrl(data.products[i].products[j].url),
                    data.products[i].products[j].name,
                    data.products[i].products[j].builderName,
                    FindCommunity(data),
                    new Lot(data.products[i].name,
                        data.products[i].products[j].type,
                        data.products[i].lotSize,
                        data.products[i].products[j].price,
                        data.products[i].marketingReleaseName,
                        data.products[i].products[j].bedrooms,
                        data.products[i].products[j].bathrooms,
                        data.products[i].products[j].garageSpaces,
                        data.products[i].products[j].storeys,
                        ExtractGUIDFromUrl(data.products[i].products[j].url),
                        "open times not available",
                        data.products[i].products[j].builderName,
                        data.products[i].lotWidth)));
            }
        }
    }


    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "view_item_list",
        ecommerce: {
            item_list_name: "Lot List",
            items: items
        }
    });
}

function ExtractGUIDFromUrl(url) {
    if (Object.is(url, null)) return "unknown";
    // get stuff between {} and send it back
    var guid = url.substring(url.indexOf("{") + 1, url.lastIndexOf("}"));
    return guid;
}

function ExtractRegionFromUrl(url) {
    // given /communities/perth-and-wa/brabham/product-details?id={DA1E7CE0-5341-4A6D-982A-65DEE660B2EA}
    var region = url.substring(13, url.indexOf("/", 14));
    return region;
}

function FindCommunity(data) {
    let community = {
        name: data.mainProject.name,
        region: data.mainProject.region,
        projectStatus: data.mainProject.availability
    };

    return community;
}

